export const difficultyMap = {
  '1': 'Easy',
  '2': 'Medium',
  '3': 'Hard',
}



// WEBPACK FOOTER //
// ./src/services/difficulty.enum.js